import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RENOVIERUNG from '../assets/renovierung.jpeg'
import TROCKENBAU from '../assets/trockenbau.jpeg'
import BODENLEGER from '../assets/bodenleger.jpeg'
import MALEREI from '../assets/malerei.jpg'
import FLIESENLEGER from '../assets/fliesenleger.jpg'
import HINTERGRUND from '../assets/hintergrund3.avif'

// Firmenlogos
import LOGO1 from "../assets/logo1.webp";
import LOGO2 from "../assets/logo2.png";
import LOGO3 from "../assets/logo3.png";

//Einsatzgebiet
import BAYERN from "../assets/bayern.png"
import PIN from "../assets/pin.jpg"

const images = [
  RENOVIERUNG,
  TROCKENBAU,
  BODENLEGER,
  MALEREI,
  FLIESENLEGER,
  HINTERGRUND
];

const HOME: React.FC = () => {
  const [current, setCurrent] = useState(0);
  // ZÄHLER STATES
  const [customers, setCustomers] = useState(0);
  const [orders, setOrders] = useState(0);

  // COUNTER EFFECT
  useEffect(() => {
    let customerCount = 0;
    let orderCount = 0;

    const counterInterval = setInterval(() => {
      if (customerCount < 80) {
        customerCount += 4;
        setCustomers(customerCount);
      }

      if (orderCount < 130) {
        orderCount += 10;
        setOrders(orderCount);
      }

      if (customerCount >= 80 && orderCount >= 130) {
        clearInterval(counterInterval);
      }
    }, 80);

    return () => clearInterval(counterInterval);
  }, []);
  return (
    <div className="bg-gray-100 text-gray-800 min-h-screen flex flex-col">

    {/* ================= HERO SECTION ================= */}
    <section
        className="relative h-[60vh] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${HINTERGRUND})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
    >
      {/* Dunkles Overlay */}
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-20 md:py-28 text-center">

        <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Ihr zuverlässiger Partner für Dienstleistungen
        </h1>

        <p className="max-w-2xl mx-auto mb-8 text-sm md:text-base text-gray-200">
          Hier bei A.B.S. GmbH ist Ihre Zufriedenheit unser oberstes Ziel.
          Schon seit unserer Gründung konzentrieren wir uns auf qualitativ
          hochwertige Arbeit. Wir arbeiten ausschließlich mit ausgewählten
          Materialien und erfahrenen Partnern, um langlebige und saubere
          Ergebnisse zu gewährleisten.
        </p>
        <div className="
          flex flex-col sm:flex-row
          gap-4
          justify-center
        ">
          {/* Primärer CTA */}
          <Link
            to="/contact"
            className="
              bg-red-600 text-white
              px-6 md:px-8 py-3
              rounded-lg
              font-semibold
              hover:bg-red-700
              transition
              text-center
            "
          >
            Angebot anfragen
          </Link>

          {/* Anrufen Button */}
          <a
            href="tel:+4917657122695"
            className="
              border-2 border-white
              text-white
              px-6 md:px-8 py-3
              rounded-lg
              font-semibold
              hover:bg-white hover:text-gray-900
              transition
              text-center
            "
          >
            Anrufen
          </a>
        </div>
      </div>
    </section>

    {/* ZAHLEN & REFERENZEN */}
    <section className="bg-gray-100 rounded-2xl p-10">
      <div className="grid md:grid-cols-2 gap-10 items-center">

        {/* Zahlen */}
        <div className="grid grid-cols-2 gap-8 text-center">
          <div>
            <p className="text-4xl font-bold text-red-600">
              {customers}+
            </p>
            <p className="text-gray-600 mt-2">Zufriedene Kunden</p>
          </div>
          <div>
            <p className="text-4xl font-bold text-red-600">
              {orders}+
            </p>
            <p className="text-gray-600 mt-2">Erfolgreiche Aufträge</p>
          </div>
        </div>

        {/* Firmenlogos */}
        <div className="grid grid-cols-3 gap-6">
          {[LOGO1, LOGO2, LOGO3].map((logo, index) => (
            <div
              key={index}
              className="h-20 bg-white rounded-xl shadow flex items-center justify-center p-4"
            >
              <img
                src={logo}
                alt="Firmenlogo"
                className="max-h-full max-w-full object-contain grayscale hover:grayscale-0 transition-all"
              />
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* ================= EINSATZGEBIET ================= */}
    <section className="max-w-4xl mx-auto px-4 space-y-6">
    <h2 className="text-3xl font-bold text-center mb-4 md:mb-8">
        Einsatzgebiet
    </h2>

    <p className="text-center text-gray-600 max-w-2xl mx-auto">
        Wir sind regional stark aufgestellt und betreuen Projekte in München,
        Augsburg, Dachau, Landshut sowie in der gesamten Umgebung.
    </p>

    <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
        {/* Kartenbild */}
        <div className="flex-shrink-0 rounded-2xl overflow-hidden shadow-lg w-full md:w-2/3">
        <img
            src={BAYERN}
            alt="Einsatzgebiet Bayern"
            className="w-full h-auto object-cover"
        />
        </div>

        {/* Städte / Pins */}
        <div className="flex flex-wrap justify-center md:justify-start gap-3 md:flex-col md:gap-4 w-full md:w-1/3">
        {["München", "Augsburg", "Dachau", "Landshut", "Viele weitere Städte"].map((city) => (
            <div
            key={city}
            className="flex items-center gap-2 bg-red-600 text-white px-3 py-1 rounded-full shadow-md text-sm font-medium hover:bg-red-700 transition-colors"
            >
            <img src={PIN} alt="" className="w-5 h-5" />
            <span>{city}</span>
            </div>
        ))}
        </div>
    </div>
    </section>

      {/* ================= SERVICES ================= */}
      <section className="bg-gray-100 py-14 md:py-20 flex-1">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">

          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 md:mb-12">
            Unsere Leistungen
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            {/* Renovierung */}
            <div className="bg-white rounded-xl shadow p-6 flex flex-col sm:flex-row gap-6">
              <img
                src={RENOVIERUNG}
                alt="Renovierung"
                className="
                  w-full sm:w-32
                  h-40 sm:h-32
                  object-cover
                  rounded-lg
                  shrink-0
                "
              />
              <div className="text-center sm:text-left">
                <h3 className="text-lg md:text-xl font-semibold mb-2">
                  Renovierung
                </h3>
                <p className="text-gray-600 mb-4 text-sm md:text-base">
                  Wir übernehmen komplette Renovierungsarbeiten zuverlässig,
                  sauber und termingerecht – von der Planung bis zur Umsetzung.
                </p>
                <Link
                  to="/services"
                  className="inline-block bg-yellow-400 px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition text-sm"
                >
                  Mehr erfahren
                </Link>
              </div>
            </div>


            {/* Trockenbau */}
            <div className="bg-white rounded-xl shadow p-6 flex flex-col sm:flex-row gap-6">
              <img
                src={TROCKENBAU}
                alt="Renovierung"
                className="
                  w-full sm:w-32
                  h-40 sm:h-32
                  object-cover
                  rounded-lg
                  shrink-0
                "
              />
              <div className="text-center sm:text-left">
                <h3 className="text-lg md:text-xl font-semibold mb-2">
                  Trockenbau
                </h3>
                <p className="text-gray-600 mb-4 text-sm md:text-base">
                  Individuelle Raumlösungen durch präzise ausgeführten Trockenbau,
                  angepasst an Ihre räumlichen und funktionalen Anforderungen.
                </p>
                <Link to="/services" className="inline-block bg-yellow-400 px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition text-sm">
                  Mehr erfahren
                </Link>
              </div>
            </div>

            {/* Bodenleger */}
            <div className="bg-white rounded-xl shadow p-6 flex flex-col sm:flex-row gap-6">
              <img
                src={BODENLEGER}
                alt="Renovierung"
                className="
                  w-full sm:w-32
                  h-40 sm:h-32
                  object-cover
                  rounded-lg
                  shrink-0
                "
              />
              <div className="text-center sm:text-left">
                <h3 className="text-lg md:text-xl font-semibold mb-2">
                  Bodenleger
                </h3>
                <p className="text-gray-600 mb-4 text-sm md:text-base">
                  Fachgerechte Verlegung hochwertiger Bodenbeläge für langlebige,
                  funktionale und optisch ansprechende Räume.
                </p>
                <Link to="/services" className="inline-block bg-yellow-400 px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition text-sm">
                  Mehr erfahren
                </Link>
              </div>
            </div>

            {/* Malerei */}
            <div className="bg-white rounded-xl shadow p-6 flex flex-col sm:flex-row gap-6">
              <img
                src={MALEREI}
                alt="Renovierung"
                className="
                  w-full sm:w-32
                  h-40 sm:h-32
                  object-cover
                  rounded-lg
                  shrink-0
                "
              />
              <div className="text-center sm:text-left">
                <h3 className="text-lg md:text-xl font-semibold mb-2">
                  Malerei
                </h3>
                <p className="text-gray-600 mb-4 text-sm md:text-base">
                  Saubere und präzise Malerarbeiten für ein modernes,
                  harmonisches Raumgefühl – innen wie außen.
                </p>
                <Link to="/services" className="inline-block bg-yellow-400 px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition text-sm">
                  Mehr erfahren
                </Link>
              </div>
            </div>

            {/* Fliesenleger */}
            <div className="bg-white rounded-xl shadow p-6 flex flex-col sm:flex-row gap-6">
              <img
                src={FLIESENLEGER}
                alt="Renovierung"
                className="
                  w-full sm:w-32
                  h-40 sm:h-32
                  object-cover
                  rounded-lg
                  shrink-0
                "
              />
              <div className="text-center sm:text-left">
                <h3 className="text-lg md:text-xl font-semibold mb-2">
                  Fliesenleger
                </h3>
                <p className="text-gray-600 mb-4 text-sm md:text-base">
                  Präzise Fliesenarbeiten für Bad, Küche und Wohnbereiche mit
                  höchstem Anspruch an Qualität und Detail.
                </p>
                <Link to="/services" className="inline-block bg-yellow-400 px-5 py-2 rounded-full font-semibold hover:bg-yellow-500 transition text-sm">
                  Mehr erfahren
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default HOME;
